import React, { Fragment, useState, useEffect, useRef } from "react";
import Box from "@material-ui/core/Box";
import DeleteIcon from "@material-ui/icons/Delete";
import Button from "@material-ui/core/Button";
import { makeStyles } from "@material-ui/core/styles";
import { DataStore } from "@aws-amplify/datastore";
import { EyepieceTwoResponse } from "models";
import IconButton from "@material-ui/core/IconButton";
const useStyles = makeStyles((theme) => ({
  imageContainer: {
    position: "relative",
    cursor:'pointer'
  },
  image: {
    maxWidth: "100%",
    maxHeight: "100%",
    height: "auto",
  },
  deleteBtn: {
    position: "absolute",
    top: 0,
    right: 0, //,
    // margin:"auto",
    // transform: "translate(-25%,25%)"
  },
  background: {
    position: "absolute",
    top: 0,
    right: 0,
    width: "100%",
    height: "100%",
    opacity: 0.5,
    backgroundColor: "black",
  },
  button: {
    margin: theme.spacing(1),
  },
}));

function Drawing(props) {
  const classes = useStyles();
  const [visible, setVisible] = useState(false);
  //   const [showOutline, setShowOutline] = useState(false);
  async function handleDelete() {
    props.onDelete(props.id);
  }

    function handleClick() {
      if (props.onClick){
        props.onClick(props.drawing);
      }
    }
  function handleEnter() {
    setVisible(true);
  }
  function handleLeave() {
    setVisible(false);
  }
  return (
    <Box
      className={classes.imageContainer}
        onClick={handleClick}
      onMouseEnter={handleEnter}
      onMouseLeave={handleLeave}
      //   style={{border:showOutline?"1px solid black":"none"}}
    >
      <img
        className={classes.image}
        src={props.drawing}
        alt="student drawing"
      />
      {/* <Box style={{display:visible?"block":"none"}} className={classes.background}/> */}
      <Box
        className={classes.deleteBtn}
        style={{ display: visible ? "block" : "none" }}
      >
        <IconButton
          variant="contained"
          //   color="primary"
          size="small"
          className={classes.button}
          onClick={handleDelete}
        >
          <DeleteIcon />
        </IconButton>
      </Box>
    </Box>
  );
}

export default Drawing;
